import {
  InsurabilityAction,
  LOAD_CHRONIC_INFORMATION,
  LOAD_INSURABILITY_ERROR,
  LOAD_INSURABILITY_START,
  LOAD_INSURABILITY_SUCCESS,
} from "store/types/insurability.types";
import * as InsurabilityApi from "api/insurability.api";
import { Dispatch } from "redux";
import { Insurability } from "model/insurability.model";

/** ---- ACTIONS ---- */
export const loadInsurability = (userId: number, patientId: number) => {
  return async (dispatch: Dispatch<InsurabilityAction>) => {
    try {
      dispatchLoadInsurabilityStart()(dispatch);
      const insurability = await InsurabilityApi.find(userId, patientId);
      dispatchLoadInsurabilitySuccess(insurability)(dispatch);
    } catch (e) {
      dispatchLoadInsurabilityError()(dispatch);
    }
  };
};

export const loadChronicInformation = (userId: number, patientId: number) => {
  return async (dispatch: Dispatch<InsurabilityAction>) => {
    const chronic = await InsurabilityApi.isChronicPatient(userId, patientId);
    dispatchChronicInformation(chronic)(dispatch);
  };
};

/** ---- DISPATCHERS ---- */
const dispatchLoadInsurabilityStart = () => {
  return (dispatch: Dispatch<InsurabilityAction>) => {
    dispatch({
      type: LOAD_INSURABILITY_START,
    });
  };
};

const dispatchLoadInsurabilitySuccess = (response: Insurability) => {
  return (dispatch: Dispatch<InsurabilityAction>) => {
    dispatch({
      type: LOAD_INSURABILITY_SUCCESS,
      payload: response,
    });
  };
};

const dispatchLoadInsurabilityError = () => {
  return (dispatch: Dispatch<InsurabilityAction>) => {
    dispatch({
      type: LOAD_INSURABILITY_ERROR,
    });
  };
};

const dispatchChronicInformation = (chronic: boolean) => {
  return (dispatch: Dispatch<InsurabilityAction>) => {
    dispatch({
      type: LOAD_CHRONIC_INFORMATION,
      payload: chronic,
    });
  };
};
